import React, { memo, useCallback, useEffect, useMemo, useState } from 'react'
import { useQuery } from 'react-query'
import { useDispatch } from 'react-redux'

import { api_gateway } from '../../conexoes/api'
import iconeSemResultadosWhite from '../../icones/iconesVersaoClara/dashboard.svg'
import iconeSemResultadosDark from '../../icones/iconesVersaoEscura/dashboard.svg'
import { mudarManejador } from '../../redux/actions/index'
import { useGlobal } from '../../stores/useGlobal.js'
import decryptJWT from '../../utils/decryptJWT'
import BlankSlate from '../BlankSlate/index.jsx'

import SkeletonCards from './SkeletonCards'
import * as S from './styles'
import VideoCard from './VideoCard'

function PainelTutoriais() {
  const despacho = useDispatch()
  const { setIsLoadingGlobal } = useGlobal()
  const [mostrarSkeleton, setMostrarSkeleton] = useState(true)
  const [videosEstado, setVideosEstado] = useState(new Set())

  const clientePrimario = decryptJWT('clientePrimario')
  const localTheme = localStorage.getItem('tema')
  const theme = localTheme || 'claro'
  const isDarkTheme = theme === 'escuro'

  const { data: videosData = [], isFetching } = useQuery(
    ['tutoriais', clientePrimario],
    async () => {
      setIsLoadingGlobal(true)
      setMostrarSkeleton(true)
      const response = await api_gateway.get(
        `/m1/consultar/tutorial?cd_cliente_primario=${clientePrimario}`
      )

      return response.data?.dados || []
    },
    {
      onError: (error) => {
        finalizarCarregamentoInicial()
        console.error(error)
      },
      keepPreviousData: false,
      refetchOnWindowFocus: false
    }
  )

  useEffect(() => {
    despacho(mudarManejador('painelTutoriais'))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const corTema = () => {
    if (isDarkTheme) return iconeSemResultadosDark
    else return iconeSemResultadosWhite
  }

  const verificarTodosVideosCarregados = useCallback(
    (totalVideos) => {
      return videosEstado.size >= totalVideos
    },
    [videosEstado]
  )

  const finalizarCarregamentoInicial = useCallback(() => {
    setMostrarSkeleton(false)
    setIsLoadingGlobal(false)
  }, [setIsLoadingGlobal, setMostrarSkeleton])

  const handleVideoLoad = useCallback((videoId) => {
    setVideosEstado((prev) => {
      if (prev.has(videoId)) {
        return prev
      }

      const novoCarregados = new Set(prev)
      novoCarregados.add(videoId)

      return novoCarregados
    })
  }, [])

  const todosCarregados = useMemo(
    () => verificarTodosVideosCarregados(videosData.length),
    [videosData.length, verificarTodosVideosCarregados]
  )

  useEffect(() => {
    if (videosData.length === 0) return

    if (todosCarregados && mostrarSkeleton) {
      finalizarCarregamentoInicial()
    }
  }, [
    videosData.length,
    todosCarregados,
    mostrarSkeleton,
    finalizarCarregamentoInicial
  ])

  return (
    <S.Container>
      {!mostrarSkeleton && !isFetching && videosData.length === 0 && (
        <S.BlankSlateContainer>
          <BlankSlate
            mb={90}
            mt={90}
            icon={corTema()}
            title="Nenhum tutorial encontrado."
            subTitle="Nenhum tutorial foi encontrado, tente novamente mais tarde."
          />
        </S.BlankSlateContainer>
      )}
      {mostrarSkeleton && <SkeletonCards />}

      <S.GridVideosHidden
        $show={!mostrarSkeleton && !isFetching && videosData.length > 0}
      >
        {videosData.map((video) => {
          const videoId = video.cd_tut_tutorial

          return (
            <VideoCard
              key={videoId}
              video={video}
              onLoad={() => handleVideoLoad(videoId)}
            />
          )
        })}
      </S.GridVideosHidden>
    </S.Container>
  )
}

export default memo(PainelTutoriais)
